import { useEffect, useState } from 'react';

import { useQuery } from 'react-query';

import { useRouter } from 'next/router';

import { CategoryByIdService, CategoryContentsService } from 'services/core';

import ContentTabs from '@core/components/searchTabs/ContentTabs';
import Spinner from '@core/components/spinner/Spinner';

import classes from './Category.module.scss';

import BackButton from '@core/components/backbutton/BackButton';
import useWindowSize from 'hooks/use-windowSize';
import Title from '@core/layouts/title/Title';
import { SUB_PAGE_TITLE } from '@core/constants/Title';

import { NextSeo } from 'next-seo';
import { getCategorySeoProps } from 'router/seoprops';

const Categories = () => {
	const router = useRouter();
	const [categoryId, setCategoryId] = useState('');
	const seoProps = getCategorySeoProps();

	useEffect(() => {
		if (router.isReady) {
			setCategoryId(router.query.id);
		}
	}, [router.asPath]);

	const { data, isLoading } = useQuery(
		['categories', categoryId],
		() => CategoryByIdService(categoryId),
		{
			enabled: Boolean(categoryId)
		}
	);
	const { desktopDevice, tabletDevice, mobileDevice } = useWindowSize();

	const titleBar = () => {
		if (desktopDevice) {
			return (
				<div className={`${classes['title-container']} container d-xl-flex flex-row`}>
					<BackButton type="bordered" />
					<div className={`${classes['page-title']}`}>{data?.data.name}</div>
				</div>
			);
		}
		if (tabletDevice) {
			return <Title type={SUB_PAGE_TITLE} text={data?.data.name} />;
		}
		return (
			<div className={classes['mobile-title-bar']}>
				<Title type={SUB_PAGE_TITLE} text={data?.data.name || 'Categories'} />
			</div>
		);
	};

	return (
		<>
			<NextSeo {...seoProps} />
			{isLoading ? (
				<div className={classes['loading']}>
					<Spinner />
				</div>
			) : (
				<div
					className={`${!mobileDevice && 'container p-0'}`}
					style={{ background: mobileDevice ? data?.data.color + 20 : 'transparent' }}>
					{titleBar()}
					<ContentTabs
						className={classes['search-tabs']}
						service={CategoryContentsService.bind(null, categoryId)}
						metadata={{
							course_count: data?.data?.course_count,
							lecture_count: data?.data?.lecture_count
						}}
						pagination
						filters={false}
						sort
						tabs
						source="category"
					/>
				</div>
			)}
		</>
	);
};

export default Categories;
